"use client";
import React from "react";
import { Box, Container, Typography, Avatar } from "@mui/material";
import { useTranslation } from "react-i18next";

const ATLAS_BLUE = "#1D8FDC";

// Placeholder avatars - replace with real image URLs later
const avatars = [
  "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Hadeesa.webp",
  "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Ramiz.webp",
  "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/Moazzam.webp",
];

const AtlasTestimonialsSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const raw = t("atlasTestimonials.items", { returnObjects: true });
  const items = Array.isArray(raw) ? raw : [];

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 6, sm: 8, md: 10 },
        backgroundColor: "#FFFFFF",
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg">
        {/* Header */}
        <Box sx={{ textAlign: "center", mb: { xs: 4, md: 6 } }}>
          <Typography
            sx={{
              fontSize: { xs: "10px", sm: "11px" },
              fontWeight: 600,
              color: ATLAS_BLUE,
              letterSpacing: "1.5px",
              textTransform: "uppercase",
              fontFamily: "var(--font-outfit)",
              mb: { xs: 1.5, sm: 2 },
            }}
          >
            {t("atlasTestimonials.label")}
          </Typography>

          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "24px", sm: "30px", md: "34px", lg: "38px" },
              fontWeight: 700,
              lineHeight: 1.25,
              color: "#14122B",
              fontFamily: "var(--font-plusjakarta)",
            }}
          >
            {t("atlasTestimonials.heading")}
          </Typography>
        </Box>

        {/* Cards */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
            gap: { xs: 2, md: 2.5 },
          }}
        >
          {items.map((item, index) => (
            <Box
              key={index}
              sx={{
                backgroundColor: "#F6F2FF",
                borderRadius: "16px",
                p: { xs: 2.5, md: 3 },
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                gap: 2.5,
                textAlign: isArabic ? "right" : "left",
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "13px", sm: "13.5px", md: "14px" },
                  color: "#2E2B4A",
                  lineHeight: 1.7,
                  fontWeight: 400,
                  fontFamily: "var(--font-outfit)",
                }}
              >
                “{item.quote}”
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                  pt: 2,
                  borderTop: "1px solid #EAE3F8",
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontSize: { xs: "13px", md: "14px" },
                      fontWeight: 700,
                      color: "#14122B",
                      fontFamily: "var(--font-plusjakarta)",
                      mb: 0.25,
                    }}
                  >
                    {item.name}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { xs: "11px", md: "12px" },
                      color: "#6B6A80",
                      lineHeight: 1.5,
                      fontFamily: "var(--font-outfit)",
                    }}
                  >
                    {item.role}
                  </Typography>
                </Box>

                <Avatar
                  src={avatars[index % avatars.length]}
                  alt={item.name}
                  sx={{
                    width: 44,
                    height: 44,
                    flexShrink: 0,
                    border: "2px solid #FFFFFF",
                  }}
                />
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default AtlasTestimonialsSection;